var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isTabPage)?_c('div',{staticClass:"footerWrap"},[_c('div',{staticClass:"footer"},_vm._l((_vm.navList),function(item){return _c('div',{key:item.index,class:['footer-nav', { selected: _vm.currentPath === item.path }],on:{"click":function($event){return _vm.handleChangeRoute(item)}}},[_c('img',{staticClass:"navIcon",attrs:{"src":require('@icon/' +
            (_vm.currentPath === item.path
              ? item.selectedIconPath
              : item.iconPath) +
            '.png'),"alt":item.text}}),_c('span',[_vm._v(_vm._s(item.text))])])}),0)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }